import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { MemberAdService } from '../member-ad.service';

@Component({
  selector: 'app-upgrade-interest-modal',
  templateUrl: './upgrade-interest-modal.component.html',
  encapsulation: ViewEncapsulation.None
})
export class UpgradeInterestModalComponent {
    constructor(private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private activeModal: NgbActiveModal
        , private adService: MemberAdService) { }


    dismiss(): void {
        this.activeModal.dismiss();
    }

    sendUpgradeInterest() {
        this.adService.sendUpgradeInterest().subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.notificationService.error(err.err.message);
            },
            complete: () => {
                console.log('Observable emitted the complete notification');
                this.activeModal.close();
            }
        })
    }
}
